import React from 'react';
import { Card } from './ui/card';
import { mockServices } from '../utils/mock';
import { Search, FileText, MessageSquare, Eye, Shield, RefreshCw } from 'lucide-react';

const iconMap = {
  Search: Search,
  FileText: FileText,
  MessageSquare: MessageSquare,
  Eye: Eye,
  Shield: Shield,
  RefreshCw: RefreshCw
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#7C2D12] mb-4">
              Our Trademark Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive trademark registration services designed to protect your brand at every stage, from initial search to ongoing monitoring and enforcement.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockServices.map((service) => {
              const IconComponent = iconMap[service.icon];
              
              return (
                <Card 
                  key={service.id}
                  className="p-8 bg-[#FFF7ED] border-2 border-[#FED7AA] hover:border-[#F97316] transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group"
                >
                  <div className="bg-[#F97316] w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-white" size={32} />
                  </div>
                  
                  <h3 className="text-xl font-bold text-[#7C2D12] mb-4">
                    {service.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </Card>
              );
            })}
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center">
            <Card className="p-8 bg-gradient-to-r from-[#7C2D12] to-[#F97316] border-0">
              <h3 className="text-3xl font-bold text-white mb-4">
                Not Sure Which Service You Need?
              </h3>
              <p className="text-white/90 text-lg mb-6 max-w-2xl mx-auto">
                Our trademark experts will review your specific situation and recommend the best protection strategy for your brand. Get started with a free consultation today.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
